<section class="hero" [class.active]="isActive" data-aos="fade-in">
  <div class="container">
    <div class="hero-body">
      <h1 class="title">{{'contact.Contact Us' | translate}}</h1>
      <div class="row g-3">
        <div class="col-sm-5">
          <h2 class="subtitle" data-aos="fade-up" data-aos-delay="100">{{'contact.contactTitle' | translate}}</h2>
          <p data-aos="fade-up" data-aos-delay="200">{{'contact.contactText' | translate}}</p>
        </div>
        <div class="col-sm-2"></div>
        <div class="col-sm-5" data-aos="fade-in" data-aos-delay="300">
          <form [formGroup]="formGroup" class="contact-form" (ngSubmit)="onSubmit()">
            <div class="form-group">
              <input type="text" class="form-control name" formControlName="name"
                placeholder="{{'contact.Full name' | translate}}..." [ngClass]="{'is-invalid': isInvalid('name')}">
              <div *ngIf="hasError('name', 'required')" class="has-error">
                {{'contact.Required' | translate}}
              </div>
            </div>
            <div class="form-group">
              <input type="text" class="form-control email" formControlName="email"
                placeholder="{{'contact.Email Address' | translate}}..." [ngClass]="{'is-invalid': isInvalid('email')}">
              <div *ngIf="hasError('email', 'required')" class="has-error">
                {{'contact.Required' | translate}}
              </div>
              <div *ngIf="hasError('email', 'pattern')" class="has-error">
                {{'contact.Invalid email' | translate}}
              </div>
            </div>
            <div class="form-group">
              <textarea class="form-control message" formControlName="message"
                placeholder="{{'contact.Write your inquiry' | translate}}..."
                [ngClass]="{'is-invalid': isInvalid('message')}">
              </textarea>
              <div *ngIf="hasError('message', 'required')" class="has-error">
                {{'contact.Required' | translate}}
              </div>
            </div>

            <div class="mt-4">
              <button class="btn btn-light w-100"
                [disabled]="loading"
                [ngClass]="{'loading': loading}">
                {{'contact.Send' | translate}}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="faq overflow-hidden">
  <div class="container">
    <h2 class="title">{{'contact.FAQs' | translate}}</h2>

    <div class="faq-list">
      <div class="row g-4">
        <div class="col-md-6" *ngFor="let q of faq; index as i">
          <div class="item" [class.active]="q.isActive"
            data-aos="fade-right" [attr.data-aos-delay]="100*i">
            <div class="head" (click)="q.isActive = !q.isActive">
              <div class="d-flex align-items-center">
                <svg class="question" viewBox="0 0 29 30">
                  <path
                    d="M12 10.8333C12.0001 10.3955 12.1151 9.96538 12.3336 9.58599C12.5521 9.20659 12.8664 8.89123 13.245 8.67146C13.6237 8.45168 14.0534 8.3352 14.4912 8.33366C14.929 8.33213 15.3596 8.4456 15.7398 8.66271C16.12 8.87983 16.4365 9.19297 16.6576 9.57083C16.8788 9.94868 16.9968 10.378 16.9999 10.8158C17.0031 11.2536 16.8912 11.6845 16.6754 12.0655C16.4597 12.4465 16.1477 12.7641 15.7707 12.9866C15.1373 13.3613 14.5 13.9306 14.5 14.6666V16.3333"
                    stroke="#585868" stroke-width="1.5" stroke-linecap="round" />
                  <path class="dot"
                    d="M14.5013 21.6667C15.2377 21.6667 15.8346 21.0697 15.8346 20.3333C15.8346 19.597 15.2377 19 14.5013 19C13.7649 19 13.168 19.597 13.168 20.3333C13.168 21.0697 13.7649 21.6667 14.5013 21.6667Z"
                    fill="#585868" />
                  <path
                    d="M27.8346 15C27.8346 21.2853 27.8346 24.428 25.8813 26.38C23.9306 28.3333 20.7866 28.3333 14.5013 28.3333C8.21597 28.3333 5.0733 28.3333 3.11997 26.38C1.16797 24.4293 1.16797 21.2853 1.16797 15C1.16797 8.71466 1.16797 5.57199 3.11997 3.61866C5.07464 1.66666 8.21597 1.66666 14.5013 1.66666C20.7866 1.66666 23.9293 1.66666 25.8813 3.61866C27.18 4.91732 27.6146 6.74266 27.7613 9.66666"
                    stroke="#585868" stroke-width="1.5" stroke-linecap="round" />
                </svg>
                <h4>{{q.title | translate}}</h4>
              </div>
              <div class="arrow-ic">
                <svg class="arrow" viewBox="0 0 10 16">
                  <path
                    d="M0.896857 8.49776L8.55973 15.799C8.68759 15.9209 8.85746 15.9889 9.03411 15.9889C9.21075 15.9889 9.38062 15.9209 9.50848 15.799L9.51673 15.7908C9.57893 15.7317 9.62846 15.6605 9.6623 15.5817C9.69615 15.5029 9.7136 15.418 9.7136 15.3322C9.7136 15.2464 9.69615 15.1615 9.6623 15.0827C9.62846 15.0038 9.57893 14.9327 9.51673 14.8736L2.30073 7.99863L9.51673 1.12638C9.57893 1.0673 9.62846 0.996172 9.6623 0.917339C9.69615 0.838506 9.7136 0.753613 9.7136 0.667822C9.7136 0.582031 9.69615 0.497137 9.6623 0.418305C9.62846 0.339472 9.57893 0.268348 9.51673 0.209259L9.50848 0.201009C9.38062 0.0791226 9.21075 0.0111266 9.03411 0.0111266C8.85746 0.0111266 8.68759 0.0791226 8.55973 0.201009L0.896857 7.50226C0.829465 7.56647 0.775814 7.64369 0.739155 7.72925C0.702496 7.81481 0.683594 7.90693 0.683594 8.00001C0.683594 8.09309 0.702496 8.18521 0.739155 8.27077C0.775814 8.35633 0.829465 8.43355 0.896857 8.49776Z"
                    fill="#585868" />
                </svg>
              </div>
            </div>
            <div class="content">
              <div>
                <p>{{q.answer| translate}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
